// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__25TP8","NormalLink":"Menu_NormalLink__20ZXo"};